import { render } from "./fallback-image.vue?vue&type=template&id=0ca32040&ts=true"
import script from "./fallback-image.ts?vue&type=script&lang=ts"
export * from "./fallback-image.ts?vue&type=script&lang=ts"

import "./fallback-image.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__